<template>
    <section class="my-4 mx-4">
        <div v-if="loaded">
            <div class="md:flex items-center justify-between">
                <div class="mt-2 p-2 w-full md:w-1/3 bg-primary-lighter text-primary rounded-md text-center">
                    <p class="text-3xl font-bold">{{ totalReferredUsers }}</p>
                    <small class="uppercase">Total Users</small>
                </div>

                <div class="mt-2 md:ml-2 p-2 w-full md:w-1/3 bg-primary-lighter text-primary rounded-md text-center">
                    <p class="text-3xl font-bold">{{ qualifiedReferredUsers }}</p>
                    <small class="uppercase">Qualified Users</small>
                </div>

                <div class="mt-2 md:ml-2 p-2 w-full md:w-1/3 bg-primary text-white rounded-md text-center">
                    <p class="text-3xl font-bold">${{ totalEarnings }}</p>
                    <small class="uppercase">Total Earnings</small>
                </div>

            </div>
            <div class="mt-4 bg-gray-light py-4 px-8 rounded md:flex md:items-center" v-if="withdrawalAvailable">
                <div class="py-2 px-4 rounded-md bg-white font-bold">
                    ${{ balanceEarnings }}
                </div>
                <div class="w-full mt-2 md:ml-2 md:mt-0 flex flex-col md:flex-row items-center justify-between">
                    Available balance right now. <a href @click.prevent="requestWithdrawal" class="text-primary font-bold" v-if="withdrawalAvailable">{{ requestWithdrawalText }}</a>
                </div>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>
        
    </section>
</template>

<script>
import AmbassadorWithdrawalRequestModal from './AmbassadorWithdrawalRequestModal.vue';

const TEXT_COPY_DEFAULT = 'COPY';
const TEXT_COPY_SUCCESS = 'COPIED!';

const TEXT_REQUEST_WITHDRAWAL_DEFAULT = 'Request a withdrawal';
const TEXT_REQUEST_WITHDRAWAL_SUCCESS = 'Withdrawal in process';

export default {
    data() {
        return {
            loaded                : false,
            link                  : window.User.ambassador_link,
            copyText              : TEXT_COPY_DEFAULT,
            requestWithdrawalText : TEXT_REQUEST_WITHDRAWAL_DEFAULT,
            totalReferredUsers    : 0,
            qualifiedReferredUsers: 0,
            totalEarnings         : 0,
            balanceEarnings       : 0,
            withdrawalAvailable   : false,
        }
    },
    mounted() {
        this.getAmbassadorSummary();
    },
    methods: {
        copyAmbassadorLink() {
            this.$copyText(this.link).then(() => {
                this.copyText = TEXT_COPY_SUCCESS;
                
                // back to default text after some time
                setTimeout(() => {
                    this.copyText = TEXT_COPY_DEFAULT;
                }, 3000);
            });
        },
        getAmbassadorSummary() {
            axios.get('/api/ambassador')
                .then(response => {
                    this.totalReferredUsers     = response.data.data.total_referred_users;
                    this.qualifiedReferredUsers = response.data.data.qualified_referred_users;
                    this.totalEarnings          = response.data.data.total_earnings;
                    this.balanceEarnings        = response.data.data.balance_earnings;
                    this.withdrawalAvailable    = response.data.data.withdrawal_available;
                    this.loaded                 = true;
                })
                .catch(console.error);
        },
        requestWithdrawal() {
            Modal.show(AmbassadorWithdrawalRequestModal, {propsData: {
                amount: this.balanceEarnings,
            }})
            .then(() => {
                this.requestWithdrawalText = TEXT_REQUEST_WITHDRAWAL_SUCCESS;
            })
            .catch(console.error);
        }
    }
}
</script>

<style>

</style>